import AccessToken from '~/Api/Authentication/AccessToken';
import mapAccessToken from '~/Api/Authentication/mapAccessToken';
import ApiClient from '~/ApiClient';

export interface Result {
	accessToken: AccessToken;
}

export default function loadAccessToken(client: ApiClient): Promise<Result> {
	return client
		.fetch('authentication', {})
		.then((response) => response.json())
		.then((response) => ({
			accessToken: mapAccessToken(response.accessToken),
		}));
}
